/*
    Module:     jv.iframe-preview.directive
    Directive:  jvIframePreview

    Write html into an iframe. Useful for sandboxing the content or rendering
    full document markup.

    Usage:

        <div jv-iframe-preview="scopeVarThatContainsHtml"></div>

 */

angular.module('jv.iframe-preview.directive', [])
.directive('jvIframePreview', ['$timeout',
    function($timeout) {
        return {
            scope: {
                'html': '=jvIframePreview'
            },
            link: function(scope, element) {
                var iframe;
                var initialized = false;

                function setHeight(iframe, win, doc) {
                    iframe.height(parseFloat(win.getComputedStyle(doc.documentElement).height) + 25);
                }

                scope.$watch('html', function(html, prev) {
                    var win, doc;
                    if (html && (html !== prev || !initialized)) {
                        if (iframe) {
                            iframe.remove();
                        }
                        iframe = angular.element('<iframe width="100%"></iframe>').appendTo(element);
                        win = iframe[0].contentWindow;
                        doc = win.document;
                        doc.open();
                        doc.write(html);
                        doc.close();
                        // set initial height after images load
                        win.addEventListener('load', function() {
                            setHeight(iframe, win, doc);
                        });
                        // Added $timeout to set height when load is not triggered.
                        $timeout(function(){
                          setHeight(iframe, win, doc);
                        },0);
                        initialized = true;
                    }

                });
            }
        };
    }
]);